import { NetworkItemType } from './network';
import { ConnectionStatus } from './status';

export const ConnectorProtocols = {
    IPSec: 'IPSEC',
    OpenVPN: 'OPENVPN',

    friendlyString(entry: string) {
        return {
            [this.IPSec]: 'IPsec',
            [this.OpenVPN]: 'OpenVPN',
        }[entry];
    },
} as const;

export type ConnectorProtocolKey = keyof Omit<typeof ConnectorProtocols, 'friendlyString'>;

export type ConnectorProtocolType = (typeof ConnectorProtocols)[ConnectorProtocolKey];

export type Connector = {
    connectionStatus: ConnectionStatus;
    id: string;
    ipV4Address: string;
    ipV6Address: string;
    name: string;
    networkItemId: string;
    networkItemName: string;
    networkItemType: (typeof NetworkItemType)[keyof typeof NetworkItemType];
    vpnRegionId: string;
    vpnRegionName: string;
    tunnelingProtocol: ConnectorProtocolType;
    splitSubnet?: null | {
        ipV4Address: string;
        ipV6Address: string;
    };
    description?: string;
};
